import { useEffect, Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { initLenis, scrollToTop } from "@/lib/lenis";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Tasks from "@/pages/Tasks";
import Agents from "@/pages/Agents";
import AgentProfile from "@/pages/AgentProfile";
import Proof from "@/pages/Proof";
import Reputation from "@/pages/Reputation";
import Explorer from "@/pages/Explorer";
import Docs from "@/pages/Docs";
import About from "@/pages/About";
import NotFound from "@/pages/NotFound";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, info) {
        console.error("ACTRA UI error:", error, info);
    }
    render() {
        if (this.state.error) {
            return (
                <div className="flex min-h-screen flex-col items-center justify-center bg-[#040811] px-6 text-center">
                    <p className="label-tech">VERIFICATION ENGINE PAUSED</p>
                    <h1 className="mt-4 font-display text-3xl font-bold uppercase tracking-tightest text-ink">
                        A SECTION FAILED TO RENDER
                    </h1>
                    <p className="mt-3 max-w-md text-sm text-mute">{String(this.state.error?.message || this.state.error)}</p>
                    <button
                        onClick={() => window.location.reload()}
                        className="mt-8 bg-[#1677FF] px-8 py-3.5 font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-white"
                    >
                        RELOAD
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

const ScrollManager = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        scrollToTop(true);
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        initLenis();
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <ScrollManager />
                <Navbar />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/tasks" element={<Tasks />} />
                        <Route path="/agents" element={<Agents />} />
                        <Route path="/agents/:id" element={<AgentProfile />} />
                        <Route path="/proof" element={<Proof />} />
                        <Route path="/reputation" element={<Reputation />} />
                        <Route path="/explorer" element={<Explorer />} />
                        <Route path="/docs" element={<Docs />} />
                        <Route path="/about" element={<About />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </main>
                <Footer />
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
